export interface FilterOption<T> {
  id: string;
  name: string;
  type: FilterTypeEnum;
  options: T[];
  showSearch?: boolean;
  placeholder?: string;
  // Add these properties for custom binding
  bindLabel: keyof T;
  bindValue: keyof T;
}

export interface FilterConfig {
  [key: string]: any; // For dynamic filter values
  search: string;
}

export enum FilterTypeEnum {
  SingleSelection = 'single',
  MultiSelection = 'multi',
}
